<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <v-form
      ref="certificateForm"
    >
      <v-row>
        <v-col class="pt-0" cols="7" md="8">
          <v-text-field :disabled="disableField" ref="phonefield" :rules="[rules.required, rules.isPhoneNumber]" outlined dense hide-details="auto" hint=" _ 제외하고 입력" v-model="phoneNumberF" :label="$t('phone')" placeholder="- 제외하고 입력"></v-text-field>
        </v-col>
        <v-col class="pt-0 pl-0 align-self-center" cols="5" md="4">
          <v-btn outlined class="default-btn" :disabled="disableSendNumber" block @click="sendNumber">인증번호발송</v-btn>
        </v-col>
        <v-col cols="12" class="pt-0" v-show="showCheckNumber">
          <span class="text-caption">인증번호가 발송되었습니다. 발송된 인증번호를 입력해주세요.</span>
        </v-col>
        <v-col cols="7" md="8" v-if="showCheckNumber">
          <v-text-field :rules="[rules.required]" outlined dense hide-details="auto" v-model="certificateNumber" label="인증번호">
          </v-text-field>
        </v-col>
        <v-col class="pl-0" cols="5" md="4" v-if="showCheckNumber">
          <v-btn outlined class="default-btn" block @click="certificate">인증번호확인</v-btn>
        </v-col>
        <v-col cols="12" class="pt-0" v-show="showCheckNumber">
          <span class="text-caption green--text">{{ curTime }}</span>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import irules from '@/utils/rules'
import { getRegisterCheck } from '@/api/greenCommon/user'
import Message from '@/utils/message'
import store from '@/store'
import { certificateNumberComplete } from '@/api/common/user'
export default {
  name: 'PhoneCertificate',
  components: {
  },
  props: {
    phoneNumber: {
      type: String,
      default: ''
    },
    toggleInit: {
      type: Boolean,
      default: true
    },
    createType: { // ID/PW 찾기 시 true, 마이페이지 수정시 false
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: true,
      rules: irules,
      phoneNumberF: '',
      fromPhoneNumber: '1111-1111',
      showCheckNumber: false,
      disableSendNumber: false,
      disableField: false,
      isCertificateOk: false, // 인증이 최종 완료된 경우 true
      certificateNumber: '',
      curTime: '',
      timer: ''
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.phoneNumberF = this.phoneNumber
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    if (this.phoneNumber !== undefined && this.phoneNumber !== '') {
      this.disableField = true
      this.$nextTick(() => {
        this.disableSendNumber = !this.$refs.certificateForm.validate()
      })
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
  },
  watch: {
    createType: function() {
      console.log(this.createType)
    },
    phoneNumber: function(value) {
      if (this.phoneNumber !== undefined && this.phoneNumber !== '') {
        this.phoneNumberF = value
        this.disableField = true
      }
    },
    phoneNumberF: function(value) {
      if (this.phoneNumberF !== undefined && this.phoneNumberF !== '') {
        this.$nextTick(() => {
          this.disableSendNumber = !this.$refs.certificateForm.validate()
        })
      }
    },
    isCertificateOk: function (value) {
      if (value) {
        this.$emit('isCertificateOk', this.phoneNumberF)
        // this.$emit('updatePhoneNumber', )
        // this.isCertificateOk = false
      }
    },
    toggleInit: function () {
      this.phoneNumberF = ''
      this.init()
    }
  },
  methods: {
    init() {
      this.stopTimer()
      this.certificateNumber = null
      this.showCheckNumber = false
      this.disableField = false
      this.isCertificateOk = false
      this.disableSendNumber = false
    },
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    startTimer() {
      let time = 180
      this.curTime = (time / 60) + ':' + (time % 60).toString().padStart(2, '0')
      this.timer = setInterval(() => {
        time = time - 1
        this.curTime = Math.floor(time / 60) + ':' + (time % 60).toString().padStart(2, '0')
        if (time === 0) {
          this.init()
          Message.warn('인증시간이 만료되었습니다.')
        }
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    sendNumber() {
      // 핸드폰 번호에 대한 체크를 마치면 sms 를 발송한다.
      // store에 정의한 regist를 사용한다.
      // 인증번호 전송하고 성공하면 store.state.regist 에 사용자이름, 핸드폰번호, 인증번호를 담아둔다.
      // store.state.regist 에 값을 담아두는 이유는 회원가입에서 디폴트 값으로 셋팅해주기 위함(수정못하도록)
      let params = {
        phone: this.phoneNumberF
      }
      getRegisterCheck(params).then(response => {
        // if (response.body > 0) {
        //   Message.warn('이미 가입된 핸드폰 번호입니다.')
        //   return
        // }
        store
          .dispatch('SendCertificateNumber', {
            name: this.name,
            fromPhoneNumber: this.phoneNumberF.toString(), // 송신자 핸드폰번호를 string 으로 변환해 보낸다
            toPhoneNumber: this.phoneNumberF.toString(), // 수신자 핸드폰번호를 string 으로 변환해보낸다.
            createType: this.createType
          })
          .then(res => {
            this.startTimer()
            this.showCheckNumber = true
            this.disableField = true // 인증번호발송 및 입력하는 시간동안 잠시 이름, 핸드폰번호 수정 못하도록 처리
            this.isCertificateOk = false
            this.disableSendNumber = true
          })
          .catch(reject => {
            // 인증번호 발송이 실패한경우 인증번호 입력부분 숨김
            Message.warn('다시 요청해주세요.')
            this.certificateNumber = null
            this.showCheckNumber = false
            this.disableField = false
            this.isCertificateOk = false
          })
      })
    },
    certificate() {
      // store.state에 있는 인증번호를 발급받을 당시의 값과 현재 인증 화면에 입력된 값 비교
      // 조건중 하나라도 부합하지 않으면 회원가입 진행할 수 없음
      if (
        this.certificateNumber
      ) {
        certificateNumberComplete(this.certificateNumber)
          .then(res => {
            if (res.body) {
              this.stopTimer()
              this.isCertificateOk = true
              this.showCheckNumber = false
              this.disableField = true
              this.disableSendNumber = true
              Message.info('인증되었습니다.')
              if (this.createType) {
                store.dispatch('ClearSession')
              }
            } else {
              Message.err('인증번호가 일치하지 않습니다.')
            }
          })
          .catch(reject => {
            // 인증 실행 경고문구 표시
            Message.err('인증번호가 일치하지 않습니다.')
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
